import { LayoutGrid, ListLink, Section } from "@in/component-library";
import React, { FC } from "react";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { ServiceCategoryResponse } from "../../models/service-category-response";

interface ServiceCategoryListProps {
  heading: string;
  serviceCategories: ServiceCategoryResponse[];
}

const ServiceCategoryList: FC<ServiceCategoryListProps> = ({ heading, serviceCategories }) => (
  <Section collapse className="service-category">
    <LayoutGrid className="service-category__grid">
      <div>
        <h2
          dangerouslySetInnerHTML={{
            __html: heading
          }}
        />
      </div>
      <div>
        {serviceCategories.map((serviceCategory) => (
          <ListLink
            onClick={() => {
              sendSiteimproveEvent("MyPage-ServiceCategory", "GoToLink", serviceCategory.title);
            }}
            key={serviceCategory.url}
            header={serviceCategory.title}
            href={`/service-category/${serviceCategory.url}`}
          />
        ))}
      </div>
    </LayoutGrid>
  </Section>
);

export default ServiceCategoryList;
